package com.bikompanion.data.rating.firebase

import dev.gitlive.firebase.FirebaseOptions
import com.bikompanion.data.BuildKonfig

/**
 * The Firebase project this build talks to, from BuildKonfig.
 *
 * Used by the browser and the desktop only; Android gets the equivalent from its merged
 * `google-services.json`. Both carry the *web* app's credentials — the desktop has no Firebase
 * app registered of its own, and firebase-java-sdk is a client SDK, so the web app's are the
 * right ones for it to borrow.
 *
 * No `storageBucket`: nothing here uses Cloud Storage, and naming a bucket that no rule allows
 * anyone to touch would only be misleading.
 */
internal fun buildFirebaseOptions(): FirebaseOptions =
    FirebaseOptions(
        applicationId = BuildKonfig.FIREBASE_APP_ID,
        apiKey = BuildKonfig.FIREBASE_API_KEY,
        databaseUrl = BuildKonfig.FIREBASE_DB_URL,
        projectId = BuildKonfig.FIREBASE_PROJECT_ID,
        gcmSenderId = BuildKonfig.FIREBASE_SENDER_ID,
        authDomain = BuildKonfig.FIREBASE_AUTH_DOMAIN,
    )
